export const TODOS = 'TODOS';
export const TODOS_BUSY = 'TODOS_BUSY';
export const TODOS_CREATE_BUSY = 'TODOS_CREATE_BUSY';
export const TODOS_AUTH_BUSY = 'TODOS_AUTH_BUSY';
export const SELECTED_TODO = 'SELECTED_TODO';
export const SELECTED_TODO_DATA = 'SELECTED_TODO_DATA';
